/* eslint-disable camelcase */
import { CriticalDatasetLabels, DetectorSmokeDirection } from '../../enum'
import Vuetify from '../../plugins/vuetify'

const _t = (text) => Vuetify.framework.lang.t(text)

export class DetectorSmokeEntry {
  constructor ({ cigarette_state = DetectorSmokeDirection.NONE, pipe_state = DetectorSmokeDirection.NONE, e_cigarette_state = DetectorSmokeDirection.NONE } = {}) {
    this.cigaretteState = cigarette_state // enums.DetectorSmokeDirection
    this.pipeState = pipe_state // enums.DetectorSmokeDirection
    this.eCigaretteState = e_cigarette_state // enums.DetectorSmokeDirection
  }

  filters () {
    const result = {}
    for (const field of Object.keys(this)) {
      result[field] = false
    }
    return result
  }

  backendModel () {
    return {
      pipe_state: this.pipeState,
      cigarette_state: this.cigaretteState,
      e_cigarette_state: this.eCigaretteState
    }
  }

  get textRepresentation () {
    const result = []

    if (this.cigaretteState !== DetectorSmokeDirection.NONE) {
      result.push(`${_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.cigaretteStateDataset`)}: ${_t(`$vuetify.criticalDataset.enums.DetectorSmokeDirection.${this.cigaretteState}`)}`)
    }

    if (this.pipeState !== DetectorSmokeDirection.NONE) {
      result.push(`${_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.pipeStateDataset`)}: ${_t(`$vuetify.criticalDataset.enums.DetectorSmokeDirection.${this.pipeState}`)}`)
    }

    if (this.eCigaretteState !== DetectorSmokeDirection.NONE) {
      result.push(`${_t(`$vuetify.criticalDataset.${CriticalDatasetLabels.DETECTORS}.eCigaretteStateDataset`)}: ${_t(`$vuetify.criticalDataset.enums.DetectorSmokeDirection.${this.eCigaretteState}`)}`)
    }

    return result.map(item => ({
      item,
      color: 'black',
      type: CriticalDatasetLabels.SMOKE_DETECTOR
    }))
  }
}
